import React from 'react';

import {StandardModelViewerRecordRenderer} from "./StandardModelViewerRecordRenderer";

export const OnlyEditableForNewModelFieldRenderer = (props) => {
    const {EditMode, IsNewModel} = props;
    const overrideEditMode = IsNewModel && EditMode;

    return <StandardModelViewerRecordRenderer
        {...props}
        EditMode={overrideEditMode}
    />;
};


